import { UseQueryOptions } from '@tanstack/react-query';
import useAppQuery from 'hooks/useAppQuery';
import { UsageType } from 'models/automation/Common';
import { GetTemplateSettingsResponse } from 'models/automation/TemplateSettings';
import API from 'services/API';

export const TEMPLATE_SETTINGS_BASE_QUERY_KEY = 'template-settings';

type ReactQueryOptions = Omit<
  UseQueryOptions<GetTemplateSettingsResponse>,
  'queryKey' | 'queryFn'
>;

type UseFetchTemplateSettingsArgs = ReactQueryOptions & {
  usageType?: UsageType;
};

const useFetchTemplateSettings = ({
  enabled = true,
  usageType = UsageType.SYSTEM,
  ...options
}: UseFetchTemplateSettingsArgs = {}) => {
  return useAppQuery<GetTemplateSettingsResponse>({
    queryKey: [TEMPLATE_SETTINGS_BASE_QUERY_KEY, usageType],
    queryFn: async () => {
      const response = await API.get<GetTemplateSettingsResponse>(
        '/api/internal/automation/templates-settings',
        {
          params: {
            usageType,
          },
        },
      );

      return response.data;
    },
    enabled,
    staleTime: 30000,
    ...options,
  });
};

export default useFetchTemplateSettings;
